<template>
  <ConfirmationModal
    :entity="number"
    :title="$t('PAUSE_NUMBER_MODAL_TITLE')"
    :cancel-button-text="$t('CANCEL')"
    :confirm-action-text="$t('PAUSE')"
    @confirm="confirmPause"
    @close="$emit('close')"
  >
    <p
      v-html="
        $t('PAUSE_NUMBER_MODAL_TEXT', { phone: number.displayNumber })
      "
    />
  </ConfirmationModal>
</template>

<script>

import { defineComponent } from 'vue';
import ConfirmationModal from '@/core/components/ConfirmationModal/ConfirmationModal.vue';
import sharedMessages from '@/core/locales';
import messages from '../../locales';

export default defineComponent({
  components: {
    ConfirmationModal,
  },
  emits: ['confirm', 'close'],
  props: {
    number: {
      type: Object,
      required: true,
      default: function() {
        return {};
      }
    },
  },
  methods: {
    confirmPause(number) {
      this.$emit('confirm', number, false);
    },
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  },
});
</script>
